'use strict';

// http://stackoverflow.com/questions/24004791/can-someone-explain-the-debounce-function-in-javascript
function debounce(fn, wait, immediate) {
  var timeout = void 0;

  return function () {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(function () {
      timeout = null;

      if (!immediate) {
        fn.apply(_this, args);
      }
    }, wait);

    if (callNow) fn.apply(this, args);
  };
}


$(function () {
  ;(function () {
    // General Slick
    $('.js-slick').slick({
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
    })

    // Collection Sidebar
    var $collectionSidebar = $('#collection-sidebar')
    if ($collectionSidebar.length) {
      var location = window.location.pathname + window.location.search
      var link = 'a[href*="' + location + '"]'
      $collectionSidebar.find(link).addClass('filter__link--active')
    }
  })();

  // Header search
  ;(function () {
    $('#hs-toggle').on('click', function (e) {
      e.preventDefault()
      e.stopPropagation()
      $(this).parent().addClass('h-search--active')
      $('#hs-bar').focus()
    })

    $('#hs-form').parent().on('click', function (e) {
      e.stopPropagation()
    })

    $('html').on('click', function () {
      $('#hs-toggle').parent().removeClass('h-search--active')
    })
  })();

  // Sticky Header
  ;(function () {
    var $cache = {
      body: $('body'),
      header: $('#HeaderContainer')
    }

    function handleResize() {
      var headerHeight = $cache.header.outerHeight() + 'px'
      $cache.body.css({ 'padding-top': headerHeight })
    }

    function handleScroll() {
      var headerHeight = $cache.header.outerHeight()
      var activeClassName = 'fixed'
      $cache.header.toggleClass(activeClassName, $(window).scrollTop() > headerHeight)
    }

    handleResize()
    $(window).on('resize', debounce(handleResize, 200))
    $(window).on('scroll', handleScroll)
  })();

  // Home page
  var $hpSlider = $('#hp-slider')
  if ($hpSlider.length) {
    var slideSpeed = +($hpSlider.data('speed'))
    var shouldFade = $hpSlider.data('fade') === 'fade'

    $hpSlider.slick({
      arrows: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      speed: slideSpeed,
      fade: shouldFade,
      autoplay: true,
    })
  }
})


$(window).on('load', function () {
  // Product Page
  ;(function () {
    var selector = document.querySelector('select.single-option-selector')

    if (selector && selector.length) {
      function listItem(option) {
        var li = document.createElement('li')
        li.dataset.value = option.value
        li.innerText = option.innerText
        return li
      }

      function makeOptions(select) {
        var elements = [].slice.call(select.querySelectorAll('option'))
        return elements.reduce(function (a, c) {
          return a.concat(listItem({ value: c.value, innerText: c.innerText }))
        }, [])
      }

      function buildOut(select) {
        var docFrag = document.createDocumentFragment()

        var ulContainer = document.createElement('ul')
        ulContainer.className = 'pp-select'

        var ulDropdown = document.createElement('ul')
        ulDropdown.className = 'pp-select__dropdown'

        var liActive = document.createElement('li')
        var firstOption = selector.querySelector('option')
        liActive.className = 'pp-select__active'
        liActive.innerText = firstOption.innerText

        var options = makeOptions(select)
        options.forEach(function (option) {
          option.className = 'pp-select__dropdown-item'
          ulDropdown.appendChild(option)
        })

        ulContainer.appendChild(liActive)
        ulContainer.appendChild(ulDropdown)
        docFrag.appendChild(ulContainer)

        var selectorWrapper = document.querySelector('.selector-wrapper')
        selectorWrapper.appendChild(docFrag)
      }

      buildOut(selector)

      var $select = {
        select: $('.pp-select'),
        active: $('.pp-select__active'),
        dropdown: $('.pp-select__dropdown'),
        dropdownItem: $('.pp-select__dropdown-item'),
        singleOptionSelector: $('.single-option-selector'),
      }

      var activeClassName = 'pp-select__dropdown-item--active'
      var $options = $(selector).find('option')

      $select.active.on('click', function () {
        $select.dropdown.toggleClass("active");
        $select.dropdown.toggle()
      })

      $select.select.on('click', function (e) {
        e.stopPropagation()
      })

      $('html').on('click', function () {
        $select.dropdown.removeClass("active");
        $select.dropdown.hide()
      })

      $select.dropdownItem.on('click', function (e) {
        
      	$select.dropdown.removeClass("active");
        var val = $(this).data('value').toString()
        var txt = $(this).text()
        var $selected = $options.filter(function () {
          return $(this).val() === val && $(this).text() === txt
        })

        if ($selected.length) {
          $selected.prop('selected', true).trigger('change')
          $select.dropdownItem.removeClass(activeClassName)
          $(this).addClass(activeClassName)
          $select.dropdown.hide()
        }
      })

      $select.dropdown.on('mouseenter', function () {
        $select.dropdownItem.removeClass(activeClassName)
      })

      $select.singleOptionSelector.hide();
    }
  })();
  
  ;(function () {
    /**
     * Logic to handle sticky content via waypoints
     * @param {Node} s.scrollable -
     * @param {Node} s.container -
     * @param {Node} s.target -
     * @param {Node} s.waypointOn -
     * @param {Node} s.waypointOff -
     * @param {Number} s.minWidth -
     * @param {Number} s.gutter -
     * @param {Number} s.animationDuration -
     */
    function waypointFactory(s) {
      var rect
      var wpOffset
      var targetWidth
      var targetHeight
      var canUse = false

      function setState(newState) {
        var initialState = {
          position: '',
          top: '',
          bottom: '',
          width: '',
        }
        var state = Object.assign({}, initialState, newState)
        assignState(state)
      }

      function assignState(state) {
        Object.keys(state).forEach(function (property) {
          s.target.style[property] = state[property],
          s.target1.style[property] = state[property]
        })
      }

      function shouldStick() {
        return window.innerWidth > s.minWidth
      }
      
      function calcRect() {
        return {
          scrollable: { height: s.scrollable.clientHeight },
          container: { width: s.container.clientWidth },
          target: s.target.getBoundingClientRect(),
          wp: s.waypointOn.getBoundingClientRect(),
        }
      }

      function calcWpOffset(target, wp) {
        var offsetTop = target.top - wp.top
        var offsetBot = target.height + offsetTop

        return {
          top: offsetTop,
          bottom: offsetBot,
        }
      }

      function assignWidth(w) {
        targetWidth = w - s.gutter
      }

      function setContainerHeight(h) {
        var height = shouldStick() ? s.scrollable.offsetHeight + 'px' : ''
        s.container.style.height = h || height
        s.container1.style.height = h || height
      }

      function unset() {
        setState({})
      }

      function fix() {
        var offset = $('#HeaderContainer').outerHeight()
        setState({
          position: 'fixed',
          width: targetWidth + 'px',
          top: wpOffset.top + offset + 'px',
        })
      }

      function absolute() {
        setState({
          position: 'absolute',
          bottom: 0,
        })
      }

      function handleOn(dir) {
        return dir === 'down'
          ? fix()
          : unset()
      }

      function handleOff(dir) {
        return dir === 'down'
          ? absolute()
          : fix()
      }

      function makeReady() {
        rect = calcRect()
        wpOffset = calcWpOffset(rect.target, rect.wp)

        if (rect.scrollable.height > rect.target.height + wpOffset.top) {
          setContainerHeight()
          assignWidth(rect.container.width)
          canUse = true
        }

      }

      function reCalc() {
        var newRect = calcRect()
        var target = { top: rect.target.top, height: newRect.target.height }
        assignWidth(newRect.container.width)

        if (s.target.style.position === 'fixed') {
          s.target.style.width = targetWidth + 'px'

          window.setTimeout(function () {
            target = { top: rect.target.top, height: calcRect().target.height }
            wpOffset = calcWpOffset(target, rect.wp)
            Waypoint.refreshAll()
          }, s.animationDuration)
        } else {
          wpOffset = calcWpOffset(target, rect.wp)
          Waypoint.refreshAll()
        }
      }

      function handleResize() {
        setContainerHeight()

        var fixContainer = $('#fix-container').height()
        var fixMe = $('#fix-me').height()
        var fixContainer1 = $('#fix-container-1').height()
        var fixMe1 = $('#fix-me-1').height()

        if (fixContainer <= fixMe || fixContainer1 <= fixMe1) {
          console.log('unset')
          setContainerHeight('auto')
          return unset()
        } else {
          console.log('Set')
          return shouldStick() ? reCalc() : unset()
        }
      }

      function handleWaypoint(toggle) {
        var fn = toggle === 'on'
          ? handleOn
          : handleOff
        return function (dir) {
          var fixContainer = $('#fix-container').height()
          var fixMe = $('#fix-me').height()
          var fixContainer1 = $('#fix-container-1').height()
          var fixMe1 = $('#fix-me-1').height()

          if (fixContainer <= fixMe  || fixContainer1 <= fixMe1) {
            setContainerHeight('auto')
            return unset()
          }
          return shouldStick() ? fn(dir) : unset()
        }
      }

      function makeWP() {
        var wpOn = new Waypoint({
          element: s.waypointOn,
          handler: handleWaypoint('on'),
          offset: function () {
            return $('#HeaderContainer').outerHeight()
          },
        })

        var wpOff = new Waypoint({
          element: s.waypointOff,
          handler: handleWaypoint('off'),
          offset: function () {
            return wpOffset.bottom + $('#HeaderContainer').outerHeight()
          },
        })
      }

      function ready() {
        return canUse
      }

      function init() {
        console.log('INITS')
        makeReady()
        canUse && makeWP()
      }

      return {
        init: init,
        canUse: ready,
        handleResize: handleResize,
      }
    }

    var opts = {
      scrollable: document.getElementById('fix-sibling'),
      container: document.getElementById('fix-container'),
      container1: document.getElementById('fix-container-1'),
      target: document.getElementById('fix-me'),
      target1: document.getElementById('fix-me-1'),
      waypointOn: document.getElementById('waypoint-on'),
      waypointOff: document.getElementById('waypoint-off'),
      minWidth: 769,
      gutter: 30,
      animationDuration: 150,
    }

    if (opts.scrollable && opts.target && opts.target1) {
      var waypoint = waypointFactory(opts)
      waypoint.init()

      waypoint.canUse()
        && window.addEventListener('resize', debounce(waypoint.handleResize, 200))
//       window.addEventListener('resize', debounce(waypoint.handleResize, 200))
    }

    var $accLinks = $('.pp-links__link')
    if ($accLinks.length) {
      $accLinks.on('click', function (e) {
        e.preventDefault()
        var $accElement = $(this).next()
        var accElementIsVisible = $accElement.is(':visible')
        $('.pp-links__acc').slideUp(150)

        if (!accElementIsVisible) {
          $accElement.slideDown(150)
        }

        if (waypoint.canUse()) {
          window.setTimeout(waypoint.handleResize, 150)
        }
      })
    }

    var $productPhotos = $('#ProductPhoto')
    var mediumUp = 'screen and (min-width: 769px)'
    var slickSettings = {
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      mobileFirst: true,
    }

    function slickFactory($target, settings) {
      // Unslick when slicked (medium up)
      var unSlick = function () {
        if ($target.hasClass('slick-initialized')) {
          $target.slick('unslick')
        }
      }

      // Slick when unslicked (small)
      var slick = function () {
        if (!$target.hasClass('slick-initialized')) {
          $target.slick(settings)
        }
      }

      return {
        match: unSlick,
        unmatch: slick,
      }
    }

    enquire.register(mediumUp, slickFactory($productPhotos, slickSettings))

    if (window.innerWidth < 769) {
      $productPhotos.slick(slickSettings)
    }

    //release page
    var releaseItemArray = $('[data-section-type="release-item"]')
    if (releaseItemArray.length > 0 ) {
      releaseItemArray.each(function(){
        var $this = $(this);
        var $productJson = $this.find('[data-product-json]')
        var $ctaContainer = $this.find('[js-release-cta-container]')
      
        var drawingEnd = moment.tz($this.data('end'), 'US/Pacific')
        var drawingStart = moment.tz($this.data('start'), 'US/Pacific')

        var now = moment();

        var timeToStart = moment.duration(drawingStart.diff(now))
        var timeToEnd = moment.duration(drawingEnd.diff(now))

        if (timeToEnd > 0) {
          if (timeToStart < 1) {
            $ctaContainer.html('<a href="'+$this.data('url')+'" class="btn btn--cta release__link">Enter Drawing</a>');
          }
        }else{
          if ($productJson.length > 0) {
            var productHandle = $productJson.data('product-handle');
            var productURL = '/products/' + productHandle;
            var productAvailable;
            $.ajax({
              type: 'GET',
              url: productURL,
              dataType: 'html',
              async: false,
              success: function(data){
                var $productForm = $(data).find('#AddToCartForm')
                if ($productForm.length > 0) {
                  productAvailable = true;
                }else{
                  productAvailable = false;
                }
              },
              error: function(data){
                productAvailable = false;
              }
            })
            if (productAvailable){
              $ctaContainer.html('<a href="'+productURL+'" class="btn btn--cta release__link">Shop Now</a>');
            }else{
              $ctaContainer.html('<span class="btn release__link" disabled>Draw Closed</span>');
            }
          }else{
            $ctaContainer.html('<span class="btn release__link" disabled>Draw Closed</span>');
          }
        }
      })
    }
  })();


})